<div [class.bright]="isBright">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <div class="row legend-sec">
                <div class="col-lg-6 ">
                    <!-- <span class="form-field-legend">Approve
                        <font color="green"> <i class="material-icons check">check</i></font>
                    </span> &nbsp; Or 
                    <span class="form-field-legend">Reject
                        <font color="red">
                            <i class="material-icons clear">clear</i>
                        </font>
                    </span> -->


                    <!-- <span>&nbsp;  DOA Data Import request.</span> -->
                </div>
                <div class="col-lg-2 text-center doctype-wrap">
                    <span>
                        <small>Work Item Type</small>
                        <i class="material-icons" title="Edit"
                            (click)="isOpenDoctypeModel = true;showModal(documentTypeModal,'sm')">edit</i>
                    </span>
                    <br />
                    <span class=" doctype-name">{{ selectedDocumentType.docTypeName }}</span>
                </div>

            </div>

            <div class="form-container">
                <div class="row form-control-sec DAO_datacss">
                    <div class="row selection-sec">
                        <div class="grid_panel">
                            <app-basic-gridview [lstData]="lstData_pending" [columnsToHide]="columnsToHide"
                                [gridTitle]="reportName_pending" [showExcelDownloadOption]="true"
                                [showSearchOption]="true" [showRecordsPerPageOption]="true" [showPagination]="true"
                                (cellClickEvent)="onGridCellClick($event)"
                                (selectallClickEvent)="selectallClick($event)" [hyperlinkCols]="hyperlinkCols"
                                [columnsToExcludeFromExport]="[]">
                            </app-basic-gridview>
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-container">
                <div class="row form-control-sec DAO_datacss">
                    <div class="row selection-sec">
                        <div class="comment-box-main">
                            <div class="row cmnt_sec_h_100">
                                <div class="col-lg-6 cmnt_sec_h_100">
                                    <label>Comments</label>
                                    <div class="cmnt_textarea_sec" [ngClass]="isCommentExpand?'expanded_textarea':''">
                                        <span class="textarea_font_sec" title="Show list of restricted keywords"
                                            (click)="showModal(restrictedKeywordModal,'sm')">
                                            <img src="../../../assets/img/transaction/info.png" alt="Info">
                                        </span>
                                        <span class="expand_textarea_sec" title="Max/Min"
                                            (click)="isCommentExpand = !isCommentExpand">
                                            <img src="../../../assets/img/transaction/expand.png" alt="Expand">
                                        </span>
                                        <span class="textarea_editor_main_sec">
                                            <span class="words_count_limit">
                                                {{wordsTotal}}
                                            </span>
                                        </span>

                                        <textarea class="cmnt_textarea" maxlength="1000" required
                                            (blur)="checkRestrictedKeywords()" [(ngModel)]="transactionComment"
                                            (keyup)="function(transactionComment)">{{transactionComment}}</textarea>
                                    </div>
                                </div>
                                <div class="col-lg-2 btnclscss">
                                    <button class="btncss mr-2 mb-2 btn_primary btn_thin"
                                        (click)="submit_request('Approved')">Approve</button>
                                </div>
                                <div class="col-lg-2 btnclscss">
                                    <button class="btncss mr-2 mb-2 btn_secondary btn_thin"
                                        (click)="submit_request('Rejected')">Reject</button>

                                </div>

                                <div class="col-lg-3">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</div>
<ng-template #restrictedKeywordModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Keyword Replacement Chart</h5>
            <button type="button" class="close model_close_btn" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <div class="table_section">
                    <div class="table-responsive tablecss mt10">
                        <table class="table custom_table">
                            <thead>
                                <tr>
                                    <th>Keywords</th>
                                    <th>Auto Replacement</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of restrictedKeywords">
                                    <td>{{ item.restrict }}</td>
                                    <td>{{ item.replace }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #documentTypeModal let-modal>
    <div class="modal-content">
        <div class="modal-header model_center_header">
            <h5 class="modal-title">Select Work Item Type</h5>
            <button type="button" class="close model_close_btn"
                (click)="isOpenDoctypeModel = false;modalReference.close()">
                <span aria-hidden="true" class="model_close_btn">×</span>
            </button>
        </div>
        <div class="modal-body custom_modal_body">
            <div class="model_content">
                <ul class="selection-list">
                    <li [class.selected]="selectedDocumentType.docTypeId == docType.docTypeId"
                        *ngFor="let docType of docTypeList" (click)="onChangeDoctype(docType)">
                        <div class="selected-check">{{ docType.docTypeName }}</div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</ng-template>